// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GuestLifetimeSpend__range___RDQGj{color:var(--white70);font-weight:400}", "",{"version":3,"sources":["webpack://./src/restaurantAdmin/components/guestLifetimeSpend/GuestLifetimeSpend.scss"],"names":[],"mappings":"AAAA,mCACE,oBAAA,CACA,eAAA","sourcesContent":[".range {\n  color: var(--white70);\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"range": "GuestLifetimeSpend__range___RDQGj"
};
export default ___CSS_LOADER_EXPORT___;
